import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "ホーム", path: "/" },
    { label: "サービス", path: "/services" },
    { label: "お問い合わせ", path: "/contact" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-lg"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 lg:px-12 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
          className="flex items-center gap-2 group"
        >
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-bank-card-line text-background-50 text-sm" />
          </div>
          <span className="text-foreground-950 font-bold text-lg tracking-tight">
            BankCheckData
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8 lg:gap-12">
          {navItems.map((item) => (
            <a
              key={item.path}
              href={item.path}
              onClick={(e) => {
                e.preventDefault();
                navigate(item.path);
              }}
              className={`text-sm font-medium transition-colors duration-300 whitespace-nowrap ${
                isActive(item.path)
                  ? "text-primary-500"
                  : "text-foreground-600 hover:text-primary-500"
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        {/* CTA Button */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="/contact"
            onClick={(e) => {
              e.preventDefault();
              navigate("/contact");
            }}
            className="text-sm text-foreground-600 font-medium hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            資料ダウンロード
          </a>
          <a
            href="/contact"
            onClick={(e) => {
              e.preventDefault();
              navigate("/contact");
            }}
            className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center hover:bg-primary-600 transition-colors"
          >
            <i className="ri-arrow-right-up-line text-background-50 text-sm" />
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="メニュー"
        >
          <i className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200 px-6 py-4">
          <div className="flex flex-col gap-4">
            {navItems.map((item) => (
              <a
                key={item.path}
                href={item.path}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(item.path);
                  setMobileMenuOpen(false);
                }}
                className={`text-sm font-medium py-2 ${
                  isActive(item.path)
                    ? "text-primary-500"
                    : "text-foreground-600"
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="/contact"
              onClick={(e) => {
                e.preventDefault();
                navigate("/contact");
                setMobileMenuOpen(false);
              }}
              className="text-sm text-primary-500 font-medium py-2"
            >
              資料ダウンロード
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}